import { render, staticRenderFns } from "./ManagePresets.vue?vue&type=template&id=39aba596&"
import script from "./ManagePresets.vue?vue&type=script&lang=ts&"
export * from "./ManagePresets.vue?vue&type=script&lang=ts&"
import style0 from "./ManagePresets.vue?vue&type=style&index=0&id=39aba596&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports